import React from 'react';
import SelectField from './form/SelectField';
import { POST_TYPES } from '../../utils/constants';

const PostTypeSelect = props => (
  <SelectField placeholder="Select type" {...props} options={POST_TYPES} />
);

export default PostTypeSelect;
